import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a22b8e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "error",
  ref: "error"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { onclick: "window.location.reload()" }, "Go back", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.name) + " 😢", 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.message), 1),
    _hoisted_2
  ], 512))
}